<template>
  <div class="custom-image-container" :style="{width: width ? width : undefined, height: height ? height : undefined}">
    <el-image
      v-if="src"
      style="width: 100%; height: 100%"
      :src="innerSrc"
      fit="contain"
      :preview-src-list="srcList"
    >
    </el-image>
    <img
      v-else
      class="default-image"
      style="object-fit: contain;"
      src="@/assets/images/default-image.jpg"
      alt=""
    >
  </div>
</template>

<script>
export default {
  name: 'AttachmentImage',
  props: ['src', 'width', 'height'],
  data() {
    return {}
  },
  computed: {
    innerSrc() {
      return `${this.src}!${this.width}X${this.height}`
    },
    srcList() {
      return [this.innerSrc]
    }
  }
}
</script>

<style scoped lang="scss">
.custom-image-container {
  display: inline-block;

  .default-image {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
